type DownloadFileOptions = {
  data: BlobPart;
  filename: string;
  mimeType?: string;
};

const downloadFile = ({
  data,
  filename,
  mimeType = 'text/csv;charset=utf-8;',
}: DownloadFileOptions) => {
  const blob = new Blob([data], { type: mimeType });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export { downloadFile };
